/**
 * Форматування розрахункових полів зміни для таблиці й картки.
 */

/** Тривалість у хвилинах → «8 год 30 хв»; без значення — «—» */
export const formatDuration = (minutes: number | null | undefined): string => {
    if (minutes === null || minutes === undefined || Number.isNaN(Number(minutes))) return '—'
    const total = Math.max(0, Math.floor(Number(minutes)))
    const hours = Math.floor(total / 60)
    const rest = total % 60
    if (hours === 0) return `${rest} хв`
    return rest === 0 ? `${hours} год` : `${hours} год ${rest} хв`
}

/** Кілометри з розділенням тисяч: 125400 → «125 400 км»; без значення — «—» */
export const formatKm = (value: number | null | undefined): string => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
    return `${Number(value)
        .toLocaleString('uk-UA')
        .replace(/[\u00a0\u202f]/g, ' ')} км`
}

const signed = (value: number, text: string): string => (value > 0 ? `+${text}` : value < 0 ? `−${text}` : text)

/** Розбіжність пробігу зі знаком: 50 → «+50 км», −1250 → «−1 250 км»; без значення — «—» */
export const formatKmDelta = (value: number | null | undefined): string => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
    return signed(Number(value), formatKm(Math.abs(Number(value))))
}

/** Відсоток розбіжності зі знаком і комою: 12.5 → «+12,5 %»; без значення — «—» */
export const formatPercentDelta = (value: number | null | undefined): string => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
    const abs = Math.abs(Number(value)).toLocaleString('uk-UA', { maximumFractionDigits: 1 })
    return signed(Number(value), `${abs} %`)
}
